import { getCouponDetails } from "@payping/redux/actions";
import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { useAsync } from "react-use";
import { useAppDispatch } from "@/utils/redux";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { LocationStateSearch } from "@/pages/Shop/Coupon/types";
import CustomCouponForm from "./forms";

const EditCoupon: React.FC = () => {
  const location = useLocation();
  const locationSearch = (location.state as LocationStateSearch)?.locationSearch;
  const { code } = useParams<{ code: string }>() as { code: string };
  const dispatch = useAppDispatch();
  const { t } = useAppTranslation();

  const { loading } = useAsync(async () => {
    if (code) {
      await dispatch(getCouponDetails(code));
    }
  }, [code]);

  return <CustomCouponForm title={t("coupon.edit.title")} loadingCoupon={loading} locationSearch={locationSearch} />;
};

export default EditCoupon;
